// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20A65","right":"styles_right__2WAk1"};